if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector('form');
				this.form.querySelector('[name=id]').disabled = false;
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector('cart-notification') ||
					document.querySelector('cart-drawer');

				const current_url = new URL(window.location);
				if (current_url.pathname === window.routes.cart_url) {
					this.isCartpage = true;
				} else {
					this.isCartpage = false;
				}
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector('cart-drawer'))
					this.submitButton.setAttribute('aria-haspopup', 'dialog');
			}

			async onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

				this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				if (this.querySelector('.loading-overlay__spinner')) {
					this.querySelector('.loading-overlay__spinner').classList.remove(
						'hidden',
					);
				}

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.id),
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							this.handleErrorMessage(response.description, response.status);

							const soldOutMessage =
								this.submitButton.querySelector('.sold-out-message');
							if (!soldOutMessage) return;
							this.submitButton.setAttribute('aria-disabled', true);
							this.submitButton.querySelector('span').classList.add('hidden');
							soldOutMessage.classList.remove('hidden');
							this.error = true;
							return;
						} else if (!this.cart || this.isCartpage) {
							window.location = window.routes.cart_url;
							return;
						}

						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{once: true},
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty'))
							this.cart.classList.remove('is-empty');
						if (!this.error) this.submitButton.removeAttribute('aria-disabled');
						if (this.querySelector('.loading-overlay__spinner')) {
							this.querySelector('.loading-overlay__spinner').classList.add(
								'hidden',
							);
						}
						if (!this.error) {
							this.miniCartMessage('success');
						}
					});
			}
			displayMessage(panel, config) {
				this.timeOutId;
				clearTimeout(this.timeOutId);
				const {backgroundColor, textColor, message, hideDelay} = config;
				let msgElement = document.querySelector('.js-cart-message');
				if (panel.classList.contains('is-visible')) {
					msgElement.style.background = backgroundColor;
					msgElement.style.color = textColor;
					msgElement.querySelector('span').innerHTML = message;
					// show message
					msgElement.classList.remove('u-opacity-0', '-u-translate-y-full');
					// Si delai renseigné on enlève le message
					if (hideDelay) {
						this.timeOutId = setTimeout(() => {
							msgElement.classList.add('u-opacity-0', '-u-translate-y-full');
							panel.removeEventListener(
								'transitionend',
								this.boundDisplayMessage,
							);
							clearTimeout(this.timeOutId);
						}, hideDelay);
					}
					// si pas de délai on enlève le message à la fermeture du panel
				} else if (!panel.classList.contains('is-visible') && !hideDelay) {
					msgElement.classList.add('u-opacity-0', '-u-translate-y-full');
					panel.removeEventListener('transitionend', this.boundDisplayMessage);
					clearTimeout(this.timeOutId);
				}
			}
			miniCartMessage(state) {
				let config;
				switch (state) {
					case 'success':
						config = {
							hideDelay: 2500,
							backgroundColor: 'var(--grey-light)',
							textColor: 'var(--black)',
							message: window.sectionsCartProductAdd,
						};
						break;
					case 'error':
						config = {
							hideDelay: false,
							backgroundColor: 'var(--red-light)',
							textColor: 'var(--red)',
							message: window.sectionsCartErrorMaxLineitem,
						};
						break;
				}

				let panel = document.querySelector(
					'.c-panel__overlay.js-cart-drawer-overlay ',
				);
				this.boundDisplayMessage = this.displayMessage.bind(
					this,
					panel,
					config,
				);
				panel.addEventListener('transitionend', this.boundDisplayMessage);
			}

			handleErrorMessage(errorMessage = false, statusCode) {
				/* 
        Pour des raison d'inté il est plus simple d'avoir les message d'erreur en dehors du <product-form>
        le errorMessageWrapper ('.js-product-error-message-wrapper') est donc dans un errorMessageContainer ('.js-collection-error-message-container') et ça doit etre un parent du <product-form>
        */
				const errorMessageContainer = this.closest(
					'.js-collection-error-message-container',
				);
				if (!errorMessageContainer) return;
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					errorMessageContainer.querySelector(
						'.js-product-error-message-wrapper',
					);
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						'.product-form__error-message',
					);

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		},
	);
}
